import { Error as ErrorIcon } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router";

import useWorkerJobStatusMonitor, { WorkerJobState } from "~/modules/app/hooks/useWorkerJobStatusMonitor";

interface ProjectExportJobStatusProps {
    icon: React.ReactNode;
    onFinished?: () => void;
    jobId: string;
    worker: string;
    url: string | undefined;
    label: string;
}

export function ExportStatus({ icon, jobId, onFinished, worker, url, label }: ProjectExportJobStatusProps) {
    const { status } = useWorkerJobStatusMonitor({
        onFinished,
        worker,
        jobId: jobId,
        skip: url !== undefined,
    });

    if (status === WorkerJobState.active) {
        return <CircularProgress size={14} />;
    }

    if (url !== undefined) {
        return (
            <Tooltip title={label}>
                <IconButton color="primary" component={Link} to={url} size="small">
                    {icon}
                </IconButton>
            </Tooltip>
        );
    }

    return <ErrorIcon />;
}
